// src/ine/inePage.jsx
import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const InePage = () => {
  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-fluid d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center me-3 mb-6 mb-lg-0">
            <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center me-3 mb-3 my-0">
              Integración INE
            </h1>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div
          id="kt_app_content_container"
          className="app-container container-fluid"
        >
          <div className="card">
            <div className="card-header card-header-stretch overflow-auto">
              <ul
                className="nav nav-stretch nav-line-tabs fw-semibold fs-6 border-transparent flex-nowrap"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <NavLink
                    to="parts"
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    role="tab"
                    aria-selected={({ isActive }) => isActive}
                  >
                    Partes
                  </NavLink>
                </li>

                <li className="nav-item" role="presentation">
                  <NavLink
                    to="registrers"
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    role="tab"
                    aria-selected={({ isActive }) => isActive}
                  >
                    Registros INE
                  </NavLink>
                </li>

                <li className="nav-item" role="presentation">
                  <NavLink
                    to="bookings"
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    role="tab"
                    aria-selected={({ isActive }) => isActive}
                  >
                    Reservas INE PEX
                  </NavLink>
                </li>

                <li className="nav-item" role="presentation">
                  <NavLink
                    to="config"
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    role="tab"
                    aria-selected={({ isActive }) => isActive}
                  >
                    Configuración
                  </NavLink>
                </li>
              </ul>
            </div>

            <div className="card-body">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InePage;
